import { AppAssessmentServer, ValidationResultsFilter, } from '@wix/ambassador-app-assessment-server/http';
const appAssessment = AppAssessmentServer('/_api/app-assessment').AppValidationService();
export const fetchInitialData = async (appId) => {
    const submissionGuidelinesResponse = await appAssessment().getAppValidationReport({
        appId,
        resultsFilter: [
            ValidationResultsFilter.RESULTS_WITH_FAILURES,
            ValidationResultsFilter.RESULTS_WITH_RECOMMENDATIONS,
        ],
        version: 'latest',
    });
    return submissionGuidelinesResponse;
};
//# sourceMappingURL=initialDataCall.js.map